import './event-repeat-delete-modal.style.sass';
import template from './event-repeat-delete-modal.tpl.pug';

class EventRepeatDeleteModalController {
    /* @ngInject */
    constructor(eventUtil) {
        this.eventUtil = eventUtil;

        this.onlyThisValue = this.eventUtil.EventRepeatSelector.OnlyThis;
        this.thisAndAllFollowingValue = this.eventUtil.EventRepeatSelector.ThisAndAllFollowing;

        this.selectOnlyThis();
    }

    get isOnlyThisSelected() {
        return this.selector === this.onlyThisValue;
    }

    selectOnlyThis() {
        this.selector = this.onlyThisValue;
    }

    selectThisAndAllFollowing() {
        this.selector = this.thisAndAllFollowingValue;
    }

    confirm() {
        return this.onClose({
            data: this.selector
        });
    }

    cancel() {
        return this.onDismiss();
    }
}

export default {
    selector: 'dbAEventRepeatDeleteModal',
    template: template(),
    controller: EventRepeatDeleteModalController,
    bindings: {
        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-repeat-delete-modal/event-repeat-delete-modal.cmpt.js